import { c as _c } from "react/compiler-runtime";
import { format, isSameDay } from 'date-fns';
import { useState } from 'react';
import { DayPicker, type DayPickerProps } from 'react-day-picker';
import { pl } from 'react-day-picker/locale';
import 'react-day-picker/style.css';
import { LightCard } from '../../data-display/Card';
import { calendarClassNames, calendarModifiersClassNames } from './calendarStyles';
import { Nav } from './Nav';
type CalendarWrapperProps = DayPickerProps & {
  allowPast?: boolean;
  availableDays?: Set<string>;
  disableUnavailableDays?: boolean;
  onMonthChange?: (month: Date) => void;
};
const capitalizeFirstLetter = (str: string) => str.charAt(0).toUpperCase() + str.slice(1);
export const CalendarWrapper = t0 => {
  const $ = _c(34);
  let availableDays;
  let onMonthChange;
  let props;
  let t1;
  let t2;
  if ($[0] !== t0) {
    ({
      allowPast: t1,
      availableDays,
      disableUnavailableDays: t2,
      onMonthChange,
      ...props
    } = t0);
    $[0] = t0;
    $[1] = availableDays;
    $[2] = onMonthChange;
    $[3] = props;
    $[4] = t1;
    $[5] = t2;
  } else {
    availableDays = $[1];
    onMonthChange = $[2];
    props = $[3];
    t1 = $[4];
    t2 = $[5];
  }
  const allowPast = t1 === undefined ? false : t1;
  const disableUnavailableDays = t2 === undefined ? false : t2;
  let t3;
  if ($[6] !== props.defaultMonth) {
    t3 = props.defaultMonth ?? new Date();
    $[6] = props.defaultMonth;
    $[7] = t3;
  } else {
    t3 = $[7];
  }
  const [month, setMonth] = useState(t3);
  let t4;
  if ($[8] !== onMonthChange) {
    t4 = newMonth => {
      setMonth(newMonth);
      onMonthChange?.(newMonth);
    };
    $[8] = onMonthChange;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const handleMonthChange = t4;
  let t5;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t5 = ["Pn", "Wt", "\u015Ar", "Czw", "Pt", "Sb", "Nd"];
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const polishWeekdays = t5;
  let t6;
  if ($[11] !== availableDays) {
    t6 = day => {
      if (!availableDays) {
        return true;
      }
      const formatted = format(day, "yyyy.MM.dd");
      return availableDays.has(formatted);
    };
    $[11] = availableDays;
    $[12] = t6;
  } else {
    t6 = $[12];
  }
  const isAvailableDay = t6;
  let t7;
  if ($[13] !== allowPast || $[14] !== availableDays || $[15] !== disableUnavailableDays || $[16] !== isAvailableDay) {
    t7 = () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);
      return day_0 => {
        if (!allowPast && day_0 < today && !isSameDay(day_0, today)) {
          return true;
        }
        if (disableUnavailableDays && availableDays) {
          return !isAvailableDay(day_0) && !isSameDay(day_0, today);
        }
        return false;
      };
    };
    $[13] = allowPast;
    $[14] = availableDays;
    $[15] = disableUnavailableDays;
    $[16] = isAvailableDay;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  const getDisabledDays = t7;
  const t8 = props.mode;
  let t9;
  if ($[18] !== allowPast) {
    t9 = {
      Nav: () => <Nav allowPast={allowPast} />
    };
    $[18] = allowPast;
    $[19] = t9;
  } else {
    t9 = $[19];
  }
  let t10;
  if ($[20] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      formatCaption: _temp,
      formatWeekdayName: date_0 => polishWeekdays[(date_0.getDay() + 6) % 7]
    };
    $[20] = t10;
  } else {
    t10 = $[20];
  }
  let t11;
  if ($[21] !== getDisabledDays) {
    t11 = getDisabledDays();
    $[21] = getDisabledDays;
    $[22] = t11;
  } else {
    t11 = $[22];
  }
  let t12;
  if ($[23] !== availableDays || $[24] !== isAvailableDay) {
    t12 = availableDays ? {
      available: isAvailableDay
    } : undefined;
    $[23] = availableDays;
    $[24] = isAvailableDay;
    $[25] = t12;
  } else {
    t12 = $[25];
  }
  const t13 = availableDays ? calendarModifiersClassNames : undefined;
  let t14;
  if ($[26] !== handleMonthChange || $[27] !== month || $[28] !== props || $[29] !== t11 || $[30] !== t12 || $[31] !== t13 || $[32] !== t9) {
    t14 = <LightCard className="w-fit rounded-lg p-4"><DayPicker locale={pl} showOutsideDays={true} animate={true} mode={t8} month={month} onMonthChange={handleMonthChange} components={t9} formatters={t10} classNames={calendarClassNames} disabled={t11} modifiers={t12} modifiersClassNames={t13} {...props} /></LightCard>;
    $[26] = handleMonthChange;
    $[27] = month;
    $[28] = props;
    $[29] = t11;
    $[30] = t12;
    $[31] = t13;
    $[32] = t9;
    $[33] = t14;
  } else {
    t14 = $[33];
  }
  return t14;
};
function _temp(date) {
  return capitalizeFirstLetter(format(date, "LLLL yyyy", {
    locale: pl
  }));
}